module.exports = __webpack_public_path__ + "static/bitmovin-91b3a78dc76922d2bf7d6aefd457ab81.png";